import { useEffect, useState } from 'react';

import Navbar from './Navbar';
import PreEmptedSpotList from './PreEmptedSpotList';
import Preview from './Preview';
import EmailHeader from './EmailHeader';
import Tools from './Tools';
import EmailContent from './EmailContent';
import { useMakeFoodRecommendation } from '../context/MakeGoodContext';
import { PreEmptedSpot } from './types';
import { getRequest } from '../common/HTTPService';

const Loader = () => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/30 backdrop-blur-[1px]">
    <div className="w-10 h-10 border-4 border-wo-blue border-t-transparent border-solid rounded-full animate-spin"></div>
  </div>
);

const HomePage = () => {
  const {
    setOfferCreated,
    currentPreEmptedSpot,
    setCurrentPreEmptedSpot,
    preEmptedSpotDetails,
    setPreEmptedSpotDetails,
    preEmptedSpotList,
    setPreEmptedSpotList,
  } = useMakeFoodRecommendation();

  const [isFetching, setIsFetching] = useState(false);
  const [isMakeGoodSuggestionFetching, setIsMakeGoodSuggestionFetching] =
    useState(false);

  useEffect(() => {
    const fetchPreEmptedSpotList = async () => {
      setIsFetching(true);
      try {
        let result = await getRequest('/api/v1/preempted-spots');
        setPreEmptedSpotList(result);
        setIsFetching(false);
      } catch (error) {
        setIsFetching(false);
        console.error('Error fetching data:', error);
      }
    };
    fetchPreEmptedSpotList();
  }, []);

  const fetchMakeGoodRecommendations = async (preEmptedSpot: PreEmptedSpot) => {
    setOfferCreated(false);
    setIsMakeGoodSuggestionFetching(true);
    setCurrentPreEmptedSpot(preEmptedSpot);
    try {
      let result = await getRequest(
        `/api/v1/makegood-recommendations?spot_id=${preEmptedSpot.spot_id}&preempted_spots_table_id=${preEmptedSpot.preempted_spots_table_id}`
      );
      setPreEmptedSpotDetails(result);
      setIsMakeGoodSuggestionFetching(false);
    } catch (error) {
      setPreEmptedSpotDetails(null);
      setIsMakeGoodSuggestionFetching(false);
    }
  };
  return (
    <div className="flex font-roboto h-screen overflow-hidden">
      <Navbar />
      <main className="flex-grow flex border-bordergrey overflow-hidden">
        {isFetching ? <Loader /> : null}
        <PreEmptedSpotList
          fetchMakeGoodRecommendations={fetchMakeGoodRecommendations}
        />
        <section className="w-3/3 bg-white flex flex-col h-full">
          {preEmptedSpotDetails || isMakeGoodSuggestionFetching ? (
            <>
              <EmailHeader timeStamp={currentPreEmptedSpot.timestamp} />
              <Tools />
              <div className="flex-grow overflow-y-auto relative">
                {isMakeGoodSuggestionFetching && (
                  <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/10 backdrop-blur-[1px]">
                    <div className="w-8 h-8 border-4 border-wo-blue border-t-transparent border-solid rounded-full animate-spin"></div>
                  </div>
                )}
                <div
                  className={`${
                    isMakeGoodSuggestionFetching
                      ? 'opacity-50 pointer-events-none'
                      : ''
                  } h-full`}
                >
                  <EmailContent
                    isMakeGoodSuggestionFetching={isMakeGoodSuggestionFetching}
                  />
                </div>
              </div>
            </>
          ) : (
            <Preview />
          )}
        </section>
      </main>
    </div>
  );
};

export default HomePage;
